export const validateData = (name, value, isProfileValid, setIsProfileValid) => {
  const validateNameLastName = () => {
    if (value.length < 3) {
      setIsProfileValid({
        ...isProfileValid,
        [name]: true
      });
      return;
    }
    setIsProfileValid({
      ...isProfileValid,
      [name]: false
    });
  };

  const validateTelephoneDni = () => {
    const regex = /^\d{8,}$/;
    if (regex.test(value)) {
      setIsProfileValid({
        ...isProfileValid,
        [name]: false
      });
      return;
    }
    setIsProfileValid({
      ...isProfileValid,
      [name]: true
    });
  };

  const validateEmail = () => {
    const regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/;

    if (regex.test(value)) {
      setIsProfileValid({
        ...isProfileValid,
        [name]: false
      });
    } else {
      setIsProfileValid({
        ...isProfileValid,
        [name]: true
      });
    }
  };

  const validatePassword = () => {
    if (value.length < 5 || value.length > 15) {
      setIsProfileValid({
        ...isProfileValid,
        [name]: true
      });
    } else {
      setIsProfileValid({
        ...isProfileValid,
        [name]: false
      });
    }
  };

  if (value === '') {
    setIsProfileValid({
      ...isProfileValid,
      [name]: true
    });
    return;
  }
  const validation = {
    nombre: () => {
      validateNameLastName();
    },
    apellido: () => {
      validateNameLastName();
    },
    telefono: () => {
      validateTelephoneDni();
    },
    dni: () => {
      validateTelephoneDni();
    },
    email: () => {
      validateEmail();
    },
    newPassword: () => {
      validatePassword();
    },
    currentPassword: () => {
      validatePassword();
    },
    password: () => {
      validatePassword();
    },
    identificador: () => {
      validateEmail();
    },
  };

  if (validation[name]) validation[name]();
};

export const handleChange = (name, e, form, setForm, formValid, setFormValid) => {
  validateData(name, e.target.value, formValid, setFormValid);
  e.preventDefault();
  setForm({
    ...form,
    [name]: e.target.value,
  });
};

export const formatearFecha = (fechaString) => {
  const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

  const fecha = new Date(fechaString);
  const diaSemana = diasSemana[fecha.getDay()];
  const dia = fecha.getDate().toString().padStart(2, '0');
  const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');

  return `${diaSemana} ${dia}/${mes}`;
};
